import type {
  FileGroup,
  FileOrDirectory,
  FileInterface,
} from './FileViewer.types';

export function getFile(
  files: FileGroup,
  testFn: (file: FileOrDirectory) => boolean
) {
  let items = [...files];

  while (items.length) {
    let item = items.shift();

    if (!item) {
      throw new Error('This should never happen (getting file)');
    }

    if (item.type === 'file') {
      const matches = testFn(item);

      if (matches) {
        return item;
      }
    }

    if (item.type === 'directory') {
      items.push(...item.contents);
    }
  }

  // There should always be exactly 1 active file.
  // If we get through this loop and haven't hit an early return, something has gone terribly wrong.
  throw new Error('No active file selected');
}

export function openFile(
  items: FileGroup,
  fileSlugToOpen: string,
  slugPrefix = ''
) {
  items.forEach((item) => {
    const slug = `${slugPrefix}/${item.name}`;

    if (item.type === 'file') {
      item.isSelected = fileSlugToOpen === slug;
    } else {
      openFile(item.contents, fileSlugToOpen, slug);
    }
  });
}

export const isFile = (
  item: FileOrDirectory
): item is FileInterface => {
  return item.type === 'file';
};
